import { render, staticRenderFns } from "./MultiUnit.vue?vue&type=template&id=1493cad5&scoped=true"
import script from "./MultiUnit.vue?vue&type=script&lang=js"
export * from "./MultiUnit.vue?vue&type=script&lang=js"
import style0 from "./MultiUnit.vue?vue&type=style&index=0&id=1493cad5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1493cad5",
  null
  
)

export default component.exports